import React from 'react';
import { Layout, Menu } from 'antd';
import {
  UserOutlined,
  KeyOutlined,
  DatabaseOutlined,
  SlidersOutlined,
} from '@ant-design/icons';
import SubMenu from 'antd/lib/menu/SubMenu';
import { Link } from 'react-router-dom';
import { Logo } from '../../assets/img';

const {Sider} = Layout;

const Aside = (props) => {
  return (
    <Sider trigger={null} collapsible collapsed={props.collapsed}>
      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <img src={Logo} height={'100px'} width={'50%'} alt='logo' />
      </div>
      <Menu theme='dark' mode='inline' style={{ height: '100%' }}>
        <Menu.Item icon={<UserOutlined />} key='9'>
          <Link to={'/dashboard'} /> Dashboard
        </Menu.Item>
        <SubMenu key={'subOne'} icon={<DatabaseOutlined />} title='Produk'>
          <Menu.Item key='1'>
            <Link to={'/dashboard/shirt'}>Shirt</Link>
          </Menu.Item>
          <Menu.Item key='2'>
            <Link to={'/dashboard/trouser/'}>Traouser</Link>
          </Menu.Item>
          <Menu.Item key='3'>
            <Link to={'/dashboard/jacket'}>Jacket</Link>
          </Menu.Item>
        </SubMenu>
        <SubMenu key={'subTwo'} icon={<KeyOutlined />} title='Create Produk'>
          <Menu.Item key='4'>
            <Link to={'/dashboard/shirt/create'}></Link>Kaos
          </Menu.Item>
          <Menu.Item key='5'>
            <Link to={'/dashboard/trouser/create'} /> Trouser
          </Menu.Item>
          <Menu.Item key='6'>
            <Link to={'/dashboard/jacket/create'} /> Jacket
          </Menu.Item>
        </SubMenu>
        <Menu.Item icon={<UserOutlined />} key='8'>
          <Link to={'/dashboard/user'} /> Users
        </Menu.Item>
        <SubMenu
          key={'subthree'}
          icon={<SlidersOutlined />}
          title='Slider'
        >
          <Menu.Item key='10'>
            <Link to={'/dashboard/slider'} /> Table Slider
          </Menu.Item>
          <Menu.Item key='11'>
            <Link to={'/dashboard/slider/create'} /> Create Slider
          </Menu.Item>
        </SubMenu>
      </Menu>
    </Sider>
  );
};

export default Aside;
